import React, { ReactElement, ReactNode, useState } from 'react';
import styles from "./style.module.scss";

interface IProps {
    children?: ReactNode

    renderTitle?(value: any): string

    opts: {
        name: string
        data: any
    }[]

}

const Tabs: React.FC<IProps> = ({ opts, children }) => {
    const [indexTab, setIndexTab] = useState(0);

    return <div>
        <div className={styles.tabs}>
            {opts.map((item, index) => <span
                key={index}
                className={styles.tab}
                data-active={index === indexTab}
                onClick={() => setIndexTab(index)}
            >
                {item.name}
            </span>)}
        </div>
        <div>
            {React.isValidElement(children)
                ? React.cloneElement(children as ReactElement, { data: opts[indexTab].data }) // Thêm prop `value`
                : children}
        </div>
    </div>;
};

export default Tabs;
